<div class="products-form-page p-4 md:p-6 lg:p-8">
  <!-- Header -->
  <div class="mb-8">
    <button
      (click)="onCancel()"
      class="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors mb-4 group"
    >
      <fa-icon
        [icon]="faArrowLeft"
        class="group-hover:-translate-x-1 transition-transform"
      ></fa-icon>
      Volver al listado
    </button>

    <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
      {{ isEditMode ? 'Editar Producto' : 'Nuevo Producto' }}
    </h1>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      {{
        isEditMode
          ? 'Modifica los datos del producto seleccionado.'
          : 'Completa la información para dar de alta un nuevo producto.'
      }}
    </p>
  </div>

  <div class="max-w-3xl">
    <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="space-y-6">
      <div
        class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl overflow-hidden shadow-sm"
      >
        <div
          class="p-6 border-b border-gray-100 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-800/30"
        >
          <h2 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
            <fa-icon [icon]="faBox" class="text-blue-500"></fa-icon>
            Información del Producto
          </h2>
        </div>

        <div class="p-6 space-y-5">
          <!-- Nombre -->
          <div>
            <label
              for="name"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
            >
              Nombre del Producto <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <input
                id="name"
                type="text"
                formControlName="name"
                placeholder="Ej. Shopify"
                class="w-full px-4 py-2 bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all dark:text-gray-200"
                [class.border-red-500]="f['name'].touched && f['name'].invalid"
              />
            </div>
            @if (f['name'].touched && f['name'].errors) {
              <div class="mt-1 text-xs text-red-500">
                @if (f['name'].errors['required']) {
                  El nombre es obligatorio.
                }
                @if (f['name'].errors['maxlength']) {
                  Máximo 255 caracteres.
                }
              </div>
            }
          </div>

          <!-- Familia de Producto -->
          <div>
            <label
              for="product_family_id"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
            >
              Familia
            </label>
            <select
              id="product_family_id"
              formControlName="product_family_id"
              class="w-full px-4 py-2 bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all dark:text-gray-200 appearance-none"
            >
              <option [ngValue]="null" disabled>Selecciona una familia</option>
              @for (family of productFamilies; track family.id) {
                <option [ngValue]="family.id">{{ family.name }}</option>
              }
            </select>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <!-- Categoría -->
            <div>
              <label
                for="category"
                class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
              >
                Categoría <span class="text-red-500">*</span>
              </label>
              <input
                id="category"
                type="text"
                formControlName="category"
                placeholder="Ej. Software"
                class="w-full px-4 py-2 bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all dark:text-gray-200"
                [class.border-red-500]="f['category'].touched && f['category'].invalid"
              />
              @if (
                f['category'].touched && f['category'].errors && f['category'].errors['required']
              ) {
                <div class="mt-1 text-xs text-red-500">La categoría es obligatoria.</div>
              }
            </div>

            <!-- Valor Estimado -->
            <div>
              <label
                for="estimated_value"
                class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
              >
                Valor Estimado <span class="text-red-500">*</span>
              </label>
              <input
                id="estimated_value"
                type="text"
                formControlName="estimated_value"
                placeholder="Ej. 1.500€ - 3.000€"
                class="w-full px-4 py-2 bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all dark:text-gray-200"
                [class.border-red-500]="
                  f['estimated_value'].touched && f['estimated_value'].invalid
                "
              />
              @if (
                f['estimated_value'].touched &&
                f['estimated_value'].errors &&
                f['estimated_value'].errors['required']
              ) {
                <div class="mt-1 text-xs text-red-500">El valor estimado es obligatorio.</div>
              }
            </div>
          </div>

          <!-- Descripción -->
          <div>
            <label
              for="description"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
            >
              Descripción <span class="text-red-500">*</span>
            </label>
            <textarea
              id="description"
              formControlName="description"
              rows="4"
              placeholder="Descripción detallada del producto..."
              class="w-full px-4 py-2 bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all dark:text-gray-200"
              [class.border-red-500]="f['description'].touched && f['description'].invalid"
            ></textarea>
            @if (
              f['description'].touched &&
              f['description'].errors &&
              f['description'].errors['required']
            ) {
              <div class="mt-1 text-xs text-red-500">La descripción es obligatoria.</div>
            }
          </div>

          <!-- Comisión -->
          <div>
            <label
              for="commission"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
            >
              Comisión (%) <span class="text-red-500">*</span>
            </label>
            <div class="relative flex items-center">
              <input
                id="commission"
                type="number"
                step="0.01"
                formControlName="commission"
                placeholder="0.00"
                class="w-full pl-4 pr-10 py-2 bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all dark:text-gray-200"
                [class.border-red-500]="f['commission'].touched && f['commission'].invalid"
              />
              <div class="absolute right-3 text-gray-400">
                <fa-icon [icon]="faPercent"></fa-icon>
              </div>
            </div>
            <p class="mt-1 text-xs text-gray-500">Introduce un valor entre 0 y 100.</p>
            @if (f['commission'].touched && f['commission'].errors) {
              <div class="mt-1 text-xs text-red-500">
                @if (f['commission'].errors['required']) {
                  La comisión es obligatoria.
                }
                @if (f['commission'].errors['min'] || f['commission'].errors['max']) {
                  Debe estar entre 0 y 100.
                }
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 pt-2">
        <button
          type="button"
          (click)="onCancel()"
          class="px-6 py-2 border border-gray-300 dark:border-gray-700 rounded-lg text-sm font-semibold text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          [disabled]="isLoading"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg transition-all shadow-sm shadow-blue-500/20 active:scale-95 flex items-center gap-2"
          [disabled]="isLoading"
        >
          @if (isLoading) {
            <div
              class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
            ></div>
            <span>Guardando...</span>
          } @else {
            <span>{{ isEditMode ? 'Actualizar Producto' : 'Crear Producto' }}</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
